import * as React from 'react'

import { LoginForm, TopNav } from '@paytrace/pt-skel/Component'
import { getLegacyDomain } from '@paytrace/pt-skel/Helper'
import { isStitchDisabled } from '@paytrace/pt-skel/Helper/Stitch'

const isLocalhost = () =>
  Boolean(window.location.href.match(/http:\/\/localhost:/))

export function Login () {
  if (!isStitchDisabled() && !isLocalhost()) {
    const legacyDomain = getLegacyDomain()
    window.location.replace(`${legacyDomain}/login.pay`)
  }
  return (
    <React.Fragment>
      <TopNav />
      <main className='main-wrapper'>
        <LoginForm />
      </main>
    </React.Fragment>
  )
}

export default Login
